import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./AgritourismL2.module.css";
import { AgritourismStore } from "./AgritourismStore";

function AgritourismL2({ distrito }) {
  const [agroturismo, setAgroturismo] = useState(null);
  const [dificuldadeAgroturismo, setDificuldadeAgroturismo] = useState(null);
  const [formaDeRenda, setFormaDeRenda] = useState(null);
  const [interesseAgroturismo, setInteresseAgroturismo] = useState(null);
  const [agroturismoOldValue, setAgroturismoOldValue] = useState(null);
  const [dificuldadeAgroturismoOldValue, setDificuldadeAgroturismoOldValue] =
    useState(null);
  const [formaDeRendaOldValue, setFormaDeRendaOldValue] = useState(null);
  const [interesseAgroturismoOldValue, setInteresseAgroturismoOldValue] =
    useState(null);

  const setAgroturismoImage = AgritourismStore(
    (state) => state.setAgroturismoImage
  );

  const setInteresseAgroturismoImage = AgritourismStore(
    (state) => state.setInteresseAgroturismoImage
  );

  const setDificuldadeAgroturismoImage = AgritourismStore(
    (state) => state.setDificuldadeAgroturismoImage
  );

  const setFormaRendaImage = AgritourismStore(
    (state) => state.setFormaRendaImage
  );

  const setAgroturismoValue = AgritourismStore(
    (state) => state.setAgroturismoValue
  );

  const setInteresseAgroturismoValue = AgritourismStore(
    (state) => state.setInteresseAgroturismoValue
  );

  const setDificuldadeAgroturismoValue = AgritourismStore(
    (state) => state.setDificuldadeAgroturismoValue
  );

  const setFormaRendaValue = AgritourismStore(
    (state) => state.setFormaRendaValue
  );

  const agroturismoValue = AgritourismStore((state) => state.agroturismoValue);
  const interesseAgroturismoValue = AgritourismStore(
    (state) => state.interesseAgroturismoValue
  );
  const dificuldadeAgroturismoValue = AgritourismStore(
    (state) => state.dificuldadeAgroturismoValue
  );
  const formaRendaValue = AgritourismStore((state) => state.formaRendaValue);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          agroturismo,
          dificuldadeAgroturismo,
          formaDeRenda,
          interesseAgroturismo,
        ] = await Promise.all([
          Api.getAgroturismo(
            distrito,
            interesseAgroturismoValue,
            dificuldadeAgroturismoValue,
            formaRendaValue
          ),
          Api.getDificuldadeAgroturismo(
            distrito,
            agroturismoValue,
            interesseAgroturismoValue,
            formaRendaValue
          ),
          Api.getFormaDeRenda(
            distrito,
            agroturismoValue,
            interesseAgroturismoValue,
            dificuldadeAgroturismoValue
          ),
          Api.getInteresseAgroturismo(
            distrito,
            agroturismoValue,
            dificuldadeAgroturismoValue,
            formaRendaValue
          ),
        ]);
        setAgroturismo(Functions.buildSmallPieGraphParams(agroturismo));
        setDificuldadeAgroturismo(
          Functions.buildPieGraphParams2(dificuldadeAgroturismo)
        );
        setFormaDeRenda(Functions.buildPieGraphParams2(formaDeRenda));
        setInteresseAgroturismo(
          Functions.buildPieGraphParams2(interesseAgroturismo)
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, [
    distrito,
    agroturismoValue,
    interesseAgroturismoValue,
    dificuldadeAgroturismoValue,
    formaRendaValue,
  ]);

  return (
    <div className={styles.agritourismL2}>
      <div className={styles.grade}>
        <div className={styles.smallPiegraph}>
          {agroturismo && (
            <SmallPieGraph
              data={agroturismo}
              text="AGROTURISMO"
              onLegendClick={setAgroturismoValue}
              currentValue={agroturismoValue}
              oldValue={agroturismoOldValue}
              onOldValue={setAgroturismoOldValue}
              onImageReady={setAgroturismoImage}
            />
          )}
        </div>
        <div className={styles.smallPiegraph}>
          {formaDeRenda && (
            <PieGraph
              data={formaDeRenda}
              text="FORMAS DE RENDA"
              onLegendClick={setFormaRendaValue}
              currentValue={formaRendaValue}
              oldValue={formaDeRendaOldValue}
              onOldValue={setFormaDeRendaOldValue}
              onImageReady={setFormaRendaImage}
            />
          )}
        </div>
        <div className={styles.smallPiegraph}>
          {interesseAgroturismo && (
            <PieGraph
              data={interesseAgroturismo}
              text="TÊM INTERESSE EM AGROTURISMO"
              onLegendClick={setInteresseAgroturismoValue}
              currentValue={interesseAgroturismoValue}
              oldValue={interesseAgroturismoOldValue}
              onOldValue={setInteresseAgroturismoOldValue}
              onImageReady={setInteresseAgroturismoImage}
            />
          )}
        </div>
        <div className={styles.smallPiegraph}>
          {dificuldadeAgroturismo && (
            <PieGraph
              data={dificuldadeAgroturismo}
              text="DIFICULDADE EM AGROTURISMO"
              onLegendClick={setDificuldadeAgroturismoValue}
              currentValue={dificuldadeAgroturismoValue}
              oldValue={dificuldadeAgroturismoOldValue}
              onOldValue={setDificuldadeAgroturismoOldValue}
              onImageReady={setDificuldadeAgroturismoImage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AgritourismL2;
